var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-chart",
    x: 0.803,
    y: 0.194,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "ph-chart-line-up"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.726,19.44c-0,0.402 -0.326,0.728 -0.728,0.728l-17.47,0c-0.402,0 -0.728,-0.326 -0.728,-0.728l-0,-14.558c-0,-0.402 0.326,-0.728 0.728,-0.728c0.402,0 0.728,0.326 0.728,0.728l-0,9.89l4.581,-4.581c0.132,-0.132 0.313,-0.213 0.514,-0.213c0.202,-0 0.383,0.081 0.515,0.213l2.397,2.397l5.522,-5.522l-1.882,-0c-0.402,-0 -0.728,-0.326 -0.728,-0.728c-0,-0.402 0.326,-0.728 0.728,-0.728l3.639,0c0.024,0 0.048,0.001 0.072,0.004c0.011,0.001 0.021,0.003 0.032,0.004c0.013,0.002 0.026,0.004 0.039,0.006c0.012,0.003 0.023,0.006 0.035,0.009c0.011,0.003 0.023,0.005 0.034,0.008c0.011,0.004 0.022,0.008 0.034,0.012c0.011,0.004 0.022,0.008 0.033,0.013c0.01,0.004 0.02,0.009 0.031,0.014c0.011,0.005 0.022,0.01 0.034,0.016c0.009,0.005 0.018,0.011 0.027,0.017c0.012,0.006 0.023,0.012 0.034,0.02c0.01,0.006 0.019,0.014 0.028,0.021c0.01,0.007 0.02,0.014 0.029,0.021c0.015,0.013 0.029,0.026 0.043,0.039c0.003,0.003 0.007,0.006 0.01,0.009c0.004,0.004 0.006,0.007 0.01,0.011c0.013,0.014 0.026,0.028 0.038,0.042c0.008,0.01 0.015,0.02 0.022,0.03c0.007,0.009 0.014,0.018 0.02,0.027c0.008,0.012 0.015,0.024 0.022,0.035c0.005,0.009 0.01,0.018 0.015,0.027c0.006,0.011 0.012,0.023 0.017,0.035c0.005,0.01 0.01,0.019 0.014,0.029c0.004,0.012 0.008,0.023 0.012,0.035c0.004,0.011 0.008,0.021 0.012,0.032c0.003,0.012 0.006,0.024 0.009,0.036c0.003,0.011 0.006,0.022 0.008,0.033c0.003,0.014 0.005,0.028 0.007,0.042c0.001,0.01 0.003,0.019 0.004,0.029c0.002,0.024 0.003,0.048 0.003,0.072l0,3.64c0,0.402 -0.326,0.727 -0.728,0.727c-0.402,0 -0.728,-0.325 -0.728,-0.727l0,-1.883l-6.036,6.037c-0.132,0.132 -0.314,0.213 -0.515,0.213c-0.201,0 -0.383,-0.081 -0.515,-0.213l-2.396,-2.397l-5.096,5.096l-0,1.882l16.742,-0c0.402,-0 0.728,0.325 0.728,0.727l-0,0Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRChart);
export default __webpack_public_path__ + "static/media/iconR-chart.16e9299104f9f0628e43a4605535df07.svg";
export { ForwardRef as ReactComponent };